import React, { useMemo, useState } from "react";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
  useRowSelect,
} from "react-table";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {
  ButtonDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import { GlobalFilter } from "./GlobalFilter";
import { COLUMNS } from "./Columns";
import { Checkbox } from "./Checkbox";
import "./Table.css";
import UUIDModal from "./UUIDModal";

export const Table = ({
  baseDir,
  baseUrl,
  token,
  loadedNodeList,
  nodeItems,
  editItem,
  viewUUID,
  assignExit,
  customContact,
  baseNode,
  network,
  deleteExit,
  handleDelete,
  handleSubmit,
  getCLIredirect,
  createItem,
  createConfig,
  leaveNetwork,
  user,
  toggleCSV,
  nodePagination,
  setNodePagination,
  demoMode,
  isStaff,
  toggleDemo,
}) => {
  const columns = useMemo(() => COLUMNS, []);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    state,
    selectedFlatRows,
    gotoPage,
    pageCount,
    setPageSize,
  } = useTable(
    {
      columns,
      data: nodeItems,
      initialState: {
        pageSize: nodePagination,
        hiddenColumns: ["parent_node", "id", "network", "uuid", "ami_state"],
      },
      autoResetPage: true,
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          {
            id: "selection;",
            width: "50",
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <Checkbox {...getToggleAllRowsSelectedProps()} />
            ),
            Cell: ({ row }) => (
              <Checkbox {...row.getToggleRowSelectedProps()} />
            ),
          },
          ...columns,
        ];
      });
    }
  );

  const { pageIndex, globalFilter } = state;

  const page_buttons = [];
  var i;
  for (i = 0; i < pageCount; i++) {
    const page = i;
    page_buttons.push(
      <button
        key={i}
        className="page_button"
        onClick={() => gotoPage(page)}
        disabled={page === pageIndex}
      >
        {page + 1}
      </button>
    );
  }

  function disabled_exit() {
    if (
      selectedFlatRows.map((row) => row.original).length !== 1 ||
      selectedFlatRows.map((row) => row.original)[0].owner !== user
    ) {
      return true;
    }
    let count = 0;
    let selectedEid = selectedFlatRows.map((row) => row.original)[0].eid;
    let selectedOwner = selectedFlatRows.map((row) => row.original)[0].owner;

    for (let key in nodeItems) {
      let node = nodeItems[key];
      if (selectedEid !== node["eid"] && selectedOwner === node["owner"]) {
        return;
      }
    }

    if (count === 0) {
      return true;
    }
  }

  function get_node_url(){
    if ( selectedFlatRows.map((row) => row.original).length === 1 ){
      if (selectedFlatRows.map((row) => row.original).parent_node){
        return "../" + selectedFlatRows.map((row) => row.original)[0].eid + "/"
      }
      else{
        return selectedFlatRows.map((row) => row.original)[0].eid + "/"
      }
    }
    return ""
  }

  function disabled_edit() {
    return (
      selectedFlatRows.map((row) => row.original).length !== 1 ||
      selectedFlatRows.map((row) => row.original)[0].owner !== user
    );
  }

  function console_access() {
    return (
      selectedFlatRows.map((row) => row.original).length !== 1 ||
      !selectedFlatRows.map((row) => row.original)[0].ami_enabled
    );
  }

  async function access_console(node_uuid) {
    let cli_redirect = await getCLIredirect(node_uuid);
    let url =
      "https://ion-azure-pm-fe.herokuapp.com/redirect?sessionId=" + cli_redirect;
    const win = window.open(url, "_blank");
    if (win != null) {
      win.focus();
    }
    return;
  }

  function update_name(item, name) {
    item.name = name;
    handleSubmit(item);
  }

  function disabled_unassign_exit() {
    if (
      selectedFlatRows.map((row) => row.original).length !== 1 ||
      selectedFlatRows.map((row) => row.original)[0].owner !== user ||
      selectedFlatRows.map((row) => row.original)[0].parent_node === null
    ) {
      return true;
    }
  }

  function disabled_delete() {
    const items = selectedFlatRows.map((row) => row.original);
    if (items.length === 0) {
      return true;
    }
    for (var item of items) {
      if (item.owner !== user) {
        return true;
      }
    }
    return false;
  }

  const [nodeActionDropdownToggle, setNodeActionDropdownToggle] =
    useState(false);
  const [networkActionDropdownToggle, setNetworkActionDropdownToggle] =
    useState(false);
  const [UUIDToggle, setUUIDToggle] = useState(false);

  function nodeDropdownToggle() {
    setNodeActionDropdownToggle(!nodeActionDropdownToggle);
  }

  function networkDropdownToggle() {
    setNetworkActionDropdownToggle(!networkActionDropdownToggle);
  }

  function uuidToggle(toggle) {
    setUUIDToggle(!UUIDToggle);
  }
  function viewNetworkUUID(uuid) {
    setUUIDToggle(!UUIDToggle);
  }

  return (
    <div className="table_area">
      <div className="dashboard_title">
        <div className="table_title">
          <h1>{network.name}</h1>
          <ButtonDropdown
            isOpen={networkActionDropdownToggle}
            toggle={networkDropdownToggle}
          >
            <DropdownToggle caret className="network_action_dropdown">
              Network Actions
            </DropdownToggle>
            <DropdownMenu left="true" className="dropdown_menu">
              <DropdownItem header className="dropdown_header">
                Network Data
              </DropdownItem>
              <div className="toolti_right" style={{ width: "100%" }}>
                <DropdownItem
                  className="dropdown_item"
                  key="network_uuid"
                  onClick={() => {
                    viewNetworkUUID(network.uuid);
                  }}
                >
                  Network UUID
                </DropdownItem>
                <span className="tooltitext">
                  {"  "}Unique Network Identifier{"  "}
                </span>
              </div>
              <div className="toolti_right" style={{ width: "100%" }}>
                <DropdownItem
                  className="dropdown_item"
                  key="csv_download"
                  onClick={() => {
                    toggleCSV();
                  }}
                >
                  Download CSV
                </DropdownItem>
                <span className="tooltitext">
                  {"  "}Download Network as CSV{"  "}
                </span>
              </div>
              <DropdownItem divider className="dropdown_divider" />
              <DropdownItem header className="dropdown_header">
                Settings
              </DropdownItem>
              <div className="toolti_right" style={{ width: "100%" }}>
                <DropdownItem
                  style={{ height: "35px" }}
                  className="dropdown_item"
                  key="custom contact"
                  onClick={() => {
                    customContact(selectedFlatRows);
                  }}
                >
                  Custom Contact
                </DropdownItem>
                <span className="tooltitext">
                  {"  "}Upload a custom contact plan to the network{"  "}
                </span>
              </div>
              <div className="toolti_right" style={{ width: "100%" }}>
                <a href={baseDir+"/networks/" + network.uuid + "/access/"}>
                  <DropdownItem className="dropdown_item" key="network_access">
                    Network Access
                  </DropdownItem>
                </a>
                <span className="tooltitext">
                  {"  "}View and manage who has access to the network{"  "}
                </span>
              </div>
              <DropdownItem
                style={{ height: "35px" }}
                className="dropdown_item_important"
                key="leave network"
                onClick={() => {
                  leaveNetwork("leaveNetworkModal");
                }}
              >
                Leave Network
              </DropdownItem>
              {isStaff ? (
                <>
                  <DropdownItem header className="dropdown_header">
                    Admin
                  </DropdownItem>
                  <DropdownItem
                    style={{ height: "35px" }}
                    className="dropdown_item"
                    key="demo mode"
                    onClick={() => {
                      toggleDemo();
                    }}
                  >
                    {demoMode ? "Disable Demo Mode" : "Enable Demo Mode"}
                  </DropdownItem>
                </>
              ) : null}
            </DropdownMenu>
          </ButtonDropdown>
        </div>
        {baseNode ? (
          <div className="base_area">
            <h1 className="base_title">Gateway Node {baseNode["eid"]}</h1>
            <a
              href={
                baseDir+"/networks/" +
                network.uuid +
                "/" +
                (baseNode["parent_node"] ? baseNode["parent_node"] + "/" : "")
              }
            >
              <button
                className="view_network_button"
                style={{ paddingLeft: "0" }}
              >
                <ArrowLeftIcon />
                {"View Parent"}
              </button>
            </a>
          </div>
        ) : null}
      </div>

      {/* HIDDEN FEATURE FOR NOW */}
      {baseNode && false ? 
      <div>
        <h3>Applications</h3>
        <p>{JSON.stringify(baseNode["application_set"])}</p></div> 
      : <></>}
      <div className="action_area">
        <GlobalFilter
          filter={globalFilter}
          setFilter={setGlobalFilter}
          placeholder="Filter nodes"
        />
        <div className="action_buttons">
          <div className="dropdown">
            <ButtonDropdown
              isOpen={nodeActionDropdownToggle}
              toggle={nodeDropdownToggle}
            >
              <DropdownToggle caret className="action_dropdown">
                Actions
              </DropdownToggle>
              <DropdownMenu right className="dropdown_menu">
                <DropdownItem header className="dropdown_header">
                  Network
                </DropdownItem>
                <div className="toolti_left" style={{ width: "100%" }}>
                  <DropdownItem
                    className="dropdown_item"
                    key="add_node"
                    onClick={() => {
                      createItem();
                    }}
                  >
                    Add Node
                  </DropdownItem>
                  <span className="tooltitext">
                    {"  "}Add a new node{"  "}
                  </span>
                </div>
                <DropdownItem divider className="dropdown_divider" />
                <DropdownItem header className="dropdown_header">
                  Nodes
                </DropdownItem>
                <div className="toolti_left" style={{ width: "100%" }}>
                  <a
                    href={get_node_url()}
                  >
                    <DropdownItem
                      className="dropdown_item"
                      key="edit_node"
                      disabled={disabled_edit()}
                      onClick={() => {
                        editItem(selectedFlatRows);
                      }}
                    >
                      View Node
                    </DropdownItem>
                  </a>

                  {disabled_edit() ? (
                    <span className="tooltitext">
                      {"  "}Select a node to view{"  "}
                    </span>
                  ) : (
                    <span className="tooltitext">
                      {"  "}View node page details{"  "}
                    </span>
                  )}
                </div>
                <div className="toolti_left" style={{ width: "100%" }}>
                  <DropdownItem
                    className="dropdown_item"
                    key="edit_node"
                    disabled={disabled_edit()}
                    onClick={() => {
                      editItem(selectedFlatRows);
                    }}
                  >
                    Edit Node
                  </DropdownItem>
                  {disabled_edit() ? (
                    <span className="tooltitext">
                      {"  "}Select a node you own to edit{"  "}
                    </span>
                  ) : (
                    <span className="tooltitext">
                      {"  "}Edit selected node{"  "}
                    </span>
                  )}
                </div>
                <div className="toolti_left" style={{ width: "100%" }}>
                  <DropdownItem
                    className="dropdown_item"
                    key="delete_node"
                    disabled={disabled_delete()}
                    onClick={() => handleDelete(selectedFlatRows)}
                  >
                    Delete Node
                  </DropdownItem>
                  {disabled_delete() ? (
                    <span className="tooltitext">
                      {"  "}Select one or more nodes you own to delete{"  "}
                    </span>
                  ) : (
                    <span className="tooltitext">
                      {"  "}Delete selected node{"  "}
                    </span>
                  )}
                </div>
                <div className="toolti_left" style={{ width: "100%" }}>
                  <DropdownItem
                    className="dropdown_item"
                    key="assign_exit"
                    disabled={disabled_exit()}
                    onClick={() => {
                      assignExit(selectedFlatRows);
                    }}
                  >
                    Assign Gateway
                  </DropdownItem>
                  {disabled_exit() ? (
                    <span className="tooltitext">
                      {"  "}Select a node to assign its gateway{"  "}
                    </span>
                  ) : (
                    <span className="tooltitext">
                      {"  "}Assign a gateway to the selected node{"  "}
                    </span>
                  )}
                </div>
                <div className="toolti_left" style={{ width: "100%" }}>
                  <DropdownItem
                    className="dropdown_item"
                    key="unassign_exit"
                    disabled={disabled_unassign_exit()}
                    onClick={() => {
                      deleteExit(selectedFlatRows);
                    }}
                  >
                    Unassign Gateway
                  </DropdownItem>
                  {disabled_unassign_exit() ? (
                    <span className="tooltitext">
                      {"  "}Select a node to unassign its gateway
                      {"  "}
                    </span>
                  ) : (
                    <span className="tooltitext">
                      {"  "}Unnasign selected node from its gateway{"  "}
                    </span>
                  )}
                </div>
                <div className="toolti_left" style={{ width: "100%" }}>
                  <DropdownItem
                    className="dropdown_item"
                    key="view_uuid"
                    disabled={disabled_edit()}
                    onClick={() => {
                      viewUUID(selectedFlatRows);
                    }}
                  >
                    Node UUID
                  </DropdownItem>
                  {disabled_edit() ? (
                    <span className="tooltitext">
                      {"  "}Select a node you own to view its UUID{"  "}
                    </span>
                  ) : (
                    <span className="tooltitext">
                      {"  "}View UUID of selected node{"  "}
                    </span>
                  )}
                </div>
                <div className="toolti_left" style={{ width: "100%" }}>
                  <DropdownItem
                    className="dropdown_item"
                    key="dtn_console"
                    disabled={console_access()}
                    onClick={() => {
                      access_console(
                        selectedFlatRows.map((row) => row.original)[0].uuid
                      );
                    }}
                  >
                    Access CLI
                  </DropdownItem>
                  {console_access() ? (
                    <span className="tooltitext">
                      {"  "}Select a Spatiam AMI enabled node to access its
                      console{"  "}
                    </span>
                  ) : (
                    <span className="tooltitext">
                      {"  "}Access Spatiam's DTN CLI{"  "}
                    </span>
                  )}
                </div>
                <DropdownItem divider className="dropdown_divider" />
                <DropdownItem header className="dropdown_header">
                  Generate
                </DropdownItem>
                <div className="toolti_left" style={{ width: "100%" }}>
                  <DropdownItem
                    className="dropdown_item"
                    key="configuration"
                    onClick={() => {
                      createConfig(
                        selectedFlatRows.map((row) => row.original)[0]
                      );
                    }}
                    disabled={
                      selectedFlatRows.map((row) => row.original).length !==
                        1 ||
                      selectedFlatRows.map((row) => row.original)[0].owner !==
                        user ||
                      selectedFlatRows.map((row) => row.original)[0]
                        .implementation === "uD3TN" ||
                      selectedFlatRows.map((row) => row.original)[0]
                        .public_ip === "Unknown"
                    }
                  >
                    Configuration
                  </DropdownItem>
                  {selectedFlatRows.map((row) => row.original).length !== 1 ||
                  selectedFlatRows.map((row) => row.original)[0].owner !==
                    user ? (
                    <span className="tooltitext">
                      {"  "}Select a node to generate its network configuration
                      (ION and HDTN support only)
                      {"  "}
                    </span>
                  ) : selectedFlatRows.map((row) => row.original)[0]
                      .public_ip === "Unknown" ? (
                    <span className="tooltitext">
                      {"  "}Define address of selected node to generate its
                      network configuration
                      {"  "}
                    </span>
                  ) : (
                    <span className="tooltitext">
                      {"  "}Network configuration generation
                      {"  "}
                    </span>
                  )}
                </div>
              </DropdownMenu>
            </ButtonDropdown>
          </div>
        </div>
      </div>

      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  width={column.width}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <ArrowDropDownIcon style={{ height: "23px" }} />
                      ) : (
                        <ArrowDropUpIcon style={{ height: "23px" }} />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr
                onClick={() => {
                  row.toggleRowSelected();
                }}
                {...row.getRowProps()}
              >
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>
                      {cell.render("Cell", {
                        update_name: update_name,
                        access_console: access_console,
                        network: network,
                        mine: row.values.owner === user,
                        demoMode: demoMode,
                      })}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {nodeItems.length === 0 && loadedNodeList ? (
        <div className="below_table_area">
          <button
            onClick={() => {
              createItem();
            }}
            className="below_table_button"
          >
            Add node
          </button>
        </div>
      ) : null}
      {nodeItems.length !== 0 && loadedNodeList ? (
        <div className="pagination_area">
          {page_buttons}
          <div className="corner_table_area">
            <button
              className="page_count_button"
              disabled={nodePagination === 3}
              onClick={() => {
                setNodePagination(setPageSize, "decrease");
              }}
            >
              -
            </button>
            <p className="page_count_text">Page size: {nodePagination}</p>
            <button
              className="page_count_button"
              disabled={nodePagination === 20}
              onClick={() => {
                setNodePagination(setPageSize, "increase");
              }}
            >
              +
            </button>
          </div>
        </div>
      ) : null}
      {UUIDToggle ? (
        <UUIDModal
          title="Network UUID UUID"
          info="Unique network identifier."
          uuid={network.uuid}
          toggle={uuidToggle}
          toggleName="UUIDmodal"
        />
      ) : null}
    </div>
  );
};
